import * as THREE from 'three';
import Experience from '../Experience';
import { GLTFLoader, RGBELoader } from 'three/examples/jsm/Addons.js';
import EventEmitter from '../Utils/EventEmitter';


export default class Room extends EventEmitter {
    constructor() {
        super();
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;
        this.loader = new GLTFLoader();
        this.experience.resources




        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Room');
        }
        //console.log(this.experience.resources.items)
        // Initialize room components here
        this.setRoom();

        // this.experience.resources.on('ready', () => {
        //     console.log(this.experience.resources);
        // })

        this.trigger('ready');

    }

    setRoom() {
        // Logic to set up the room goes here

        // console.log('Room model loaded successfully:', gltf);
        this.model = this.experience.resources.items.room_model_min.scene;
        //console.log('Room model loaded(gltf.scene):', this.model);
        this.model.scale.set(1, 1, 1);
        this.model.position.set(0, 0, 0);
        this.scene.add(this.model);

        if (this.debug.active) {
            this.debugFolder.add(this.model.scale, 'x', 0.1, 5).name('Room Scale X');
            this.debugFolder.add(this.model.scale, 'y', 0.1, 5).name('Room Scale Y');
            this.debugFolder.add(this.model.scale, 'z', 0.1, 5).name('Room Scale Z');
        }
        // traverse the model 
        this.model.traverse((child) => {
            if (child.isMesh) {
                child.material = child.material.clone(); // 避免材质共享问题
            }
            if (child.name === "Table") {
                child.material.map = this.experience.resources.items.table_map;
                child.material.map.colorSpace = THREE.SRGBColorSpace;
                child.material.map.flipY = false; // 避免贴图颠倒
                child.material.needsUpdate = true;
            }
            if (child.name === "Wall") {
                // 设置到另一个uv

                child.material.map = this.experience.resources.items.wall_map;
                child.material.map.colorSpace = THREE.SRGBColorSpace;
                child.material.map.flipY = false;
                // 关键：让map使用uv1 (专门给烘焙贴图使用的uv)
                if (child.geometry.attributes.uv1) {
                    child.material.map.channel = 1; // 仅three r150+支持
                    // 或者手动赋值（兼容旧版three.js）：
                    child.geometry.setAttribute('uv', child.geometry.attributes.uv1);
                }
                child.material.needsUpdate = true;
            }
            if (child.name === "window") {
                child.material.map = this.experience.resources.items.window_map;
                child.material.map.colorSpace = THREE.SRGBColorSpace;
                child.material.map.flipY = false;
                // 关键：让map使用uv1
                if (child.geometry.attributes.uv1) {
                    child.material.map.channel = 1; // 仅three r150+支持
                    // 或者手动赋值（兼容旧版three.js）：
                    child.geometry.setAttribute('uv', child.geometry.attributes.uv1);
                }
                child.material.needsUpdate = true;
            }
        });
        this.trigger('ready')

    }

    update() {
        // Logic to update the room each frame goes here
    }
}